import axios from 'axios';
import { DefaultUser } from 'constants/defaultValues';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_LIMBER_API_BASE_URL,
});

axiosInstance.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axiosInstance.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axiosInstance.defaults.headers.common['x-user'] = DefaultUser;

export const getRequest = async (path, config = {}) => axiosInstance.get(path, config);

export const putRequest = (path, body) => axiosInstance.put(path, body);

export const patchRequest = (path, body) => axiosInstance.patch(path, body);

export const postRequest = (path, body, options) => axiosInstance.post(path, body, options);

export const deleteRequest = (path, body) => axiosInstance.delete(path, body);
